module.exports = __webpack_public_path__ + "media/media/values/vlidimir-poleschuk-8b603aabc3a91044b0870ac7d7f3e633.jpg";